import React,{Component} from 'react'
import {
    BrowserRouter as Router,
    // Switch,
    // Route,
    Link,
    // useParams
  } from "react-router-dom";
// import { Link } from "react-router-dom";
// const contentful = require("contentful");
// import { documentToHtnlString } from "contentful/rich-text-html-renderer";
import Client from "../contentful";
import about_banner from '../img/about-banner-img.jpg';
import about_bio_img from '../img/about-bio-img.jpg';
import team_img_4 from '../img/team-img-4.jpg';
import team_img_2 from '../img/team-img-2.jpg';
import team_img_5 from '../img/team-img-5.jpg';

// const API = "http://localhost:8000/products/products/"


import * as contentful from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import StudentCenteredPartnership from '../components/studentcenteredpartnership';

import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton,NavDropdown , Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'


export default class OrganizationStructure extends Component {
 
   
    constructor(props){
        super(props);
        this.state = {
            // isLoaded:false,
            
            banner:"",
            image:""
        }
     
    }

    formatData(items) {
      let tempItems = items.map(item => {
        let id = item.sys.id;
        
        let banner = item.fields.bannerImage?.fields?.file?.url
        let image = item.fields.image?.fields?.file?.url
        
        // console.log(email)
        this.setState({
            banner: banner,
            image: image
        })
      });
      return tempItems;
      console.log(items)

    }
    
    componentDidMount() {
        Client.getEntries({
            content_type : "organizationStructure"
          })
          .then(response=>{
            console.log(response.items)
            this.formatData(response.items)
          })

    }
      



    render() {
      function mouseenter0() {
        
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }

      function mouseleave0(){
        const button = document.getElementById('dropdown-basic0')
        button.click()
      }
      function mouseenter1() {
        
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseleave1(){
        const button = document.getElementById('dropdown-basic1')
        button.click()
      }

      function mouseenter2() {
        
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }

      function mouseleave2(){
        const button = document.getElementById('dropdown-basic2')
        button.click()
      }
      function mouseenter3() {
        
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }

      function mouseleave3(){
        const button = document.getElementById('dropdown-basic3')
        button.click()
      }
      function mouseenter4() {
        
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }

      function mouseleave4(){
        const button = document.getElementById('dropdown-basic4')
        button.click()
      }
        return(
            <div>
           
           <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px",  marginLeft:"1rem",marginRight:"5rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem",
          marginLeft:"10px" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter0} onMouseLeave={mouseleave0}> 
        
       <Dropdown>
  <Dropdown.Toggle variant="bg-light" id="dropdown-basic0" >
  <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item ><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
    <Dropdown.Item ><Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter1} onMouseLeave={mouseleave1}> 
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic1" >
        <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter2} onMouseLeave={mouseleave2}>
         
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic2" >
        <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/transfers" style={{color: "black"}}>Transfers</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter3} onMouseLeave={mouseleave3}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic3" >
        <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
        {/* <Dropdown.Item ><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <div style={{marginTop:"8px"}} onMouseEnter={mouseenter4} onMouseLeave={mouseleave4}>
      
      <Dropdown>
        <Dropdown.Toggle variant="bg-light" id="dropdown-basic4" >
        <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item ><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
        <Dropdown.Item ><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link></Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
      </div>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem",
    marginLeft:"10px"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>  

           <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner carousel-slider">
    <div class="carousel-item active">	
      <img class="d-block w-100" src={this.state.banner} alt="First slide" />
      <div class="carousel-caption carousel-caption-center">
	    <h1>Organisation Structure</h1>
	  </div>
    </div>
  </div>
</div>

 




<div class="container mb-5">
      {/* <h2 class="font-w-600 mt-5 mb-5">A Student Centered Partnership</h2> */}
      <h2 class="font-w-600 mt-5 mb-5">A Student Centered Partnership</h2>
         <img src={this.state.image} class="img-fluid organisation-diagram" />

         <div class="row mt-5">
         <StudentCenteredPartnership />


            






         </div>

      
</div>

      

   </div>

            
        )
    }
}